// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,500;1,400;1,500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.project_table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  white-space: nowrap;
  background-color: #ffffff;
}
.project_table table {
  table-layout: fixed;
}
.project_table th {
  overflow: hidden;
  white-space: nowrap; /* Запрет переноса текста в ячейках */
  overflow: hidden; /* Скрываем излишки текста */
  text-overflow: ellipsis;
}
.project_table td {
  font-style: italic;
  font-weight: 400;
  overflow: hidden;
  text-align: right;
  align-items: left;
  padding: 3px 5px;
  border-right: 0.02px solid rgba(88, 89, 93, 0.2941176471);
}
.project_table td:last-child {
  border-right: 0;
  text-align: center;
  justify-content: center;
  align-items: center;
}

@media screen and (min-width: 1024px) and (max-width: 1439px) {
  .kpf_table_overflow {
    width: 100em;
  }
}

.block_table {
  display: inline-block;
  border-spacing: 0;
}
.block_table .dnd_theader {
  position: sticky;
  top: 0;
  background-color: #ffffff;
  z-index: 2;
}
.block_table .dnd_theader .th {
  background: #dae1ec;
}
.block_table .tr :last-child .td {
  border-bottom: 0;
}
.block_table .th,
.block_table .td {
  text-align: right;
  margin: 0;
  padding: 0.5rem;
  border-bottom: 1px solid rgba(88, 89, 93, 0.2078431373);
  border-right: 1px solid rgba(88, 89, 93, 0.2078431373);
  position: relative;
}
.block_table .th .disable,
.block_table .td .disable {
  color: rgba(79, 81, 82, 0.3490196078);
  background-color: rgba(82, 82, 82, 0.0509803922);
}
.block_table .th :last-child,
.block_table .td :last-child {
  border-right: 0;
}
.block_table .th.th_res,
.block_table .td.th_res {
  width: 1.7em;
}
.block_table .th .resizer,
.block_table .td .resizer {
  background: #f9f9f9;
  width: 0.4em;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  transform: translateX(50%);
  z-index: 1;
  touch-action: none;
}
.block_table .th .resizer.isResizing,
.block_table .td .resizer.isResizing {
  background: rgb(88, 168, 218);
}
.block_table .item_selected {
  font-weight: 550;
  background-color: rgba(66, 108, 166, 0.0470588235);
}
.block_table .th {
  text-align: center;
}
.block_table .td {
  font-style: italic;
  font-weight: 400;
}

.project_list {
  max-width: 100%;
  height: 100%;
  overflow-x: hidden;
  background: #ffffff;
  background: #ffffff;
  border-bottom: 0;
  position: relative;
}
.project_list.scrollX {
  overflow-x: auto;
}
.project_list tr:nth-child(even) {
  background-color: rgba(233, 241, 251, 0.4);
}
.project_list tr:nth-child(odd) {
  background-color: white;
}
.project_list tbody tr:hover {
  background-color: rgba(66, 108, 166, 0.1843137255);
}
.project_list:focus {
  outline: none;
}

.tableCenterText tr td {
  text-align: center;
}

.project_list_kp {
  max-width: 100%;
  height: 100%;
  overflow-x: hidden;
  background: #ffffff;
  margin-bottom: 5px;
  background: #ffffff;
  border: 1px solid rgba(88, 89, 93, 0.2078431373);
  border-bottom: 0;
  position: relative;
}
.project_list_kp.scrollX {
  overflow-x: scroll;
}
.project_list_kp .kpf_table_tr:hover {
  background-color: rgba(66, 108, 166, 0.1843137255);
}

.row-even {
  background-color: rgba(233, 241, 251, 0.4);
}

.row-odd {
  background-color: white;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 15px rgba(103, 149, 187, 0.566);
}

::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 15px rgba(103, 149, 187, 0.486);
}

.radio_container {
  display: flex;
  justify-content: center;
}

.circules_box {
  width: 14px;
  height: 14px;
  position: relative;
  -webkit-user-select: none;
  user-select: none;
}
.circules_box .circule1 {
  position: absolute;
  top: 0;
  left: 0;
  height: 14px;
  width: 14px;
  background-color: #eee;
  border-radius: 50%;
}
.circules_box .circule2 {
  position: absolute;
  top: 3.3px;
  left: 3.3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.availability_circule_box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin: 0 10px;
}
.availability_circule_box .outer_circle {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: content-box;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: white;
  border: 1px solid rgba(66, 108, 166, 0.368627451);
}
.availability_circule_box .outer_circle .inner_circle {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.item_selected td {
  text-decoration: underline;
  font-weight: 550;
}

td {
  white-space: nowrap; /* Запрет переноса текста на новую строку */
  overflow: hidden; /* Скрытие текста, выходящего за пределы ячейки */
  text-overflow: ellipsis;
}

.table {
  max-width: 48vw;
  display: inline-block;
  border-spacing: 0;
}
.table .tr :last-child .td {
  border-bottom: 0;
}
.table .th,
.table .td {
  margin: 0;
  padding: 0.5rem;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
  position: relative;
}
.table .th :last-child,
.table .td :last-child {
  border-right: 0;
}
.table .th .resizer,
.table .td .resizer {
  display: inline-block;
  background: blue;
  width: 5px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  transform: translateX(50%);
  z-index: 1;
  touch-action: none;
}
.table .th .resizer.isResizing,
.table .td .resizer.isResizing {
  background: red;
}

.table_container {
  max-width: 50vw;
}

thead {
  width: 100%;
  position: sticky;
  height: auto;
  top: 0;
  background: white;
  z-index: 50;
  overflow: auto;
  border-bottom: 0.01px solid rgba(88, 89, 93, 0.2941176471);
  border-collapse: separate;
}
thead th {
  border-collapse: separate;
  font-style: normal;
  font-weight: 500;
  color: #426ba6;
  align-items: center;
  text-align: center;
  border-right: 0.01px solid rgba(88, 89, 93, 0.2941176471);
  border-bottom: 0.01px solid rgba(88, 89, 93, 0.2941176471);
}
thead th:last-child {
  border-right: 0;
}

table thead {
  border-collapse: separate;
}
table tbody {
  border-collapse: collapse;
}

.table_with_bb {
  max-width: 100%;
  overflow-x: scroll;
  background: #ffffff;
  margin-bottom: 5px;
  background: #ffffff;
  border: 1px solid rgba(88, 89, 93, 0.2078431373);
  border-bottom: 0;
  position: relative;
}
.table_with_bb thead {
  height: 1.5em;
}
.table_with_bb thead tr {
  background-color: rgba(66, 108, 166, 0.1843137255);
}
.table_with_bb table tr {
  border-bottom: 1px solid rgba(66, 108, 166, 0.231372549);
}
.table_with_bb table tr:hover {
  background-color: rgba(66, 108, 166, 0.1843137255);
}
.table_with_bb table tr:last-child {
  border-bottom: 0;
}

.table_dnd_container {
  overflow-x: scroll;
}
.table_dnd_container .project_list {
  overflow-x: scroll;
}

.table_xscroll__container .project_list {
  overflow-x: auto;
}

.strikethroughRow {
  position: relative;
  text-decoration: line-through;
  color: #a3b9d9;
}

.sortableHeader {
  position: relative;
  cursor: pointer;
}
.sortableHeader::after {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 6px;
  height: 6px;
  background-image: linear-gradient(to bottom right, transparent 50%, #426ba6 0);
}`, "",{"version":3,"sources":["webpack://./src/Styles/List.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAKhB;EAGE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AAJF;AAME;EACE,mBAAA;AAJJ;AAOE;EACE,gBAAA;EACA,mBAAA,EAAA,qCAAA;EACA,gBAAA,EAAA,4BAAA;EACA,uBAAA;AALJ;AAQE;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yDAAA;AANJ;AAOI;EACE,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AALN;;AAkCE;EADF;IAEI,YAAA;EA9BF;AACF;;AAiCA;EACE,qBAAA;EACA,iBAAA;AA9BF;AAmCE;EACE,gBAAA;EACA,MAAA;EAGA,yBAAA;EACA,UAAA;AAnCJ;AAoCI;EACE,mBAAA;AAlCN;AA2CM;EACE,gBAAA;AAzCR;AA8CE;;EAEE,iBAAA;EACA,SAAA;EACA,eAAA;EACA,uDAAA;EACA,sDAAA;EAEA,kBAAA;AA7CJ;AA8CI;;EACE,qCAAA;EACA,gDAAA;AA3CN;AA6CI;;EACE,eAAA;AA1CN;AA4CI;;EACE,YAAA;AAzCN;AA4CI;;EAEE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,0BAAA;EACA,UAAA;EAEA,kBAAA;AA3CN;AA6CM;;EACE,6BAAA;AA1CR;AA8CE;EAGE,gBAAA;EACA,kDAAA;AA9CJ;AAiDE;EACE,kBAAA;AA/CJ;AAkDE;EACE,kBAAA;EACA,gBAAA;AAhDJ;;AAoDA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EAEA,mBAAA;EAEA,gBAAA;EACA,kBAAA;AAnDF;AAoDE;EACE,gBAAA;AAlDJ;AAoDE;EAEE,0CAAA;AAnDJ;AAsDE;EACE,uBAAA;AApDJ;AAyDM;EACE,kDAAA;AAvDR;AA2DE;EACE,aAAA;AAzDJ;;AA8DE;EACE,kBAAA;AA3DJ;;AA+DA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gDAAA;EACA,gBAAA;EACA,kBAAA;AA5DF;AA6DE;EACE,kBAAA;AA3DJ;AA8DE;EACE,kDAAA;AA5DJ;;AA+DA;EACE,0CAAA;AA5DF;;AA+DA;EACE,uBAAA;AA5DF;;AA+DA;EACE,UAAA;AA5DF;;AA8DA;EACE,qDAAA;AA3DF;;AA6DA;EACE,qDAAA;AA1DF;;AA4DA;EACE,aAAA;EACA,uBAAA;AAzDF;;AA2DA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EAGA,iBAAA;AAxDF;AA0DE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AAxDJ;AA0DE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAxDJ;;AA4DA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AAzDF;AA2DE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,uBAAA;EAEA,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,uBAAA;EACA,iDAAA;AA3DJ;AA6DI;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AA3DN;;AAiEE;EACE,0BAAA;EACA,gBAAA;AA9DJ;;AAkEA;EACE,mBAAA,EAAA,2CAAA;EACA,gBAAA,EAAA,iDAAA;EACA,uBAAA;AA/DF;;AAkEA;EACE,eAAA;EACA,qBAAA;EACA,iBAAA;AA/DF;AAoEM;EACE,gBAAA;AAlER;AAuEE;;EAEE,SAAA;EACA,eAAA;EACA,8BAAA;EACA,6BAAA;EACA,kBAAA;AArEJ;AAuEI;;EACE,eAAA;AApEN;AAuEI;;EACE,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,0BAAA;EACA,UAAA;EAEA,kBAAA;AArEN;AAuEM;;EACE,eAAA;AApER;;AA0EA;EACE,eAAA;AAvEF;;AA0EA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,MAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,0DAAA;EACA,yBAAA;AAvEF;AAwEE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EAEA,yDAAA;EACA,0DAAA;AAvEJ;AAwEI;EACE,eAAA;AAtEN;;AA2EE;EACE,yBAAA;AAxEJ;AA0EE;EACE,yBAAA;AAxEJ;;AA4EA;EACE,eAAA;EAEA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gDAAA;EACA,gBAAA;EACA,kBAAA;AA1EF;AA4EE;EACE,aAAA;AA1EJ;AA2EI;EACE,kDAAA;AAzEN;AA6EI;EACE,wDAAA;AA3EN;AA4EM;EACE,kDAAA;AA1ER;AA4EM;EACE,gBAAA;AA1ER;;AAgFA;EAGE,kBAAA;AA/EF;AA4FE;EACE,kBAAA;AA1FJ;;AA8FE;EACE,gBAAA;AA3FJ;;AAuGA;EACE,kBAAA;EACA,6BAAA;EACA,cAAA;AApGF;;AAuGA;EACE,kBAAA;EACA,eAAA;AApGF;AAsGE;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,8EAAA;AApGJ","sourcesContent":["// @import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');\n// @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;1,500&display=swap');\n\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,500;1,400;1,500&display=swap\");\n\n.project_table {\n  // overflow-y: auto;\n\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  white-space: nowrap;\n  background-color: #ffffff;\n\n  table {\n    table-layout: fixed;\n  }\n\n  th {\n    overflow: hidden;\n    white-space: nowrap; /* Запрет переноса текста в ячейках */\n    overflow: hidden; /* Скрываем излишки текста */\n    text-overflow: ellipsis;\n  }\n\n  td {\n    font-style: italic;\n    font-weight: 400;\n    overflow: hidden;\n    text-align: right;\n    align-items: left;\n    padding: 3px 5px;\n    border-right: 0.02px solid #58595d4b;\n    &:last-child {\n      border-right: 0;\n      text-align: center;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n\n  // tr {\n  //   height: 10px;\n  // }\n}\n\n// .kpf_table_overflow {\n//   @media screen and (min-width: 1024px) and (max-width: 1439px) {\n//     overflow-x: scroll;\n//   }\n// }\n// .kpf_table_table_width {\n//   width: 120em;\n//   @media screen and (min-width: 1024px) {\n//     height: 10em;\n//   }\n//   @media screen and (min-width: 1440px) {\n//     height: 15em;\n//     width: 100%;\n//   }\n//   @media screen and (min-width: 1805px) {\n//     height: 24em;\n//   }\n// }\n\n.kpf_table_overflow {\n  @media screen and (min-width: 1024px) and (max-width: 1439px) {\n    width: 100em;\n  }\n}\n\n.block_table {\n  display: inline-block;\n  border-spacing: 0;\n  // border: 1px solid black;\n  // width: 500px;\n  // position: relative;\n\n  .dnd_theader {\n    position: sticky;\n    top: 0;\n    // width: 100%;\n    // max-width: inherit;\n    background-color: #ffffff;\n    z-index: 2;\n    .th {\n      background: #dae1ec;\n    }\n  }\n  // .dnd_tbody {\n  //   // margin-top: 2em;\n  // }\n\n  .tr {\n    :last-child {\n      .td {\n        border-bottom: 0;\n      }\n    }\n  }\n\n  .th,\n  .td {\n    text-align: right;\n    margin: 0;\n    padding: 0.5rem;\n    border-bottom: 1px solid #58595d35;\n    border-right: 1px solid #58595d35;\n\n    position: relative;\n    .disable {\n      color: #4f515259;\n      background-color: #5252520d;\n    }\n    :last-child {\n      border-right: 0;\n    }\n    &.th_res {\n      width: 1.7em;\n    }\n\n    .resizer {\n      // display: inline-block;\n      background: #f9f9f9;\n      width: 0.4em;\n      height: 100%;\n      position: absolute;\n      right: 0;\n      top: 0;\n      transform: translateX(50%);\n      z-index: 1;\n\n      touch-action: none;\n\n      &.isResizing {\n        background: rgb(88, 168, 218);\n      }\n    }\n  }\n  .item_selected {\n    // .td{\n    // text-decoration: underline;\n    font-weight: 550;\n    background-color: #426ca60c;\n    // }\n  }\n  .th {\n    text-align: center;\n  }\n\n  .td {\n    font-style: italic;\n    font-weight: 400;\n  }\n}\n\n.project_list {\n  max-width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  background: #ffffff;\n  // margin-bottom: 5px;\n  background: #ffffff;\n  // border: 1px solid #58595d35;\n  border-bottom: 0;\n  position: relative;\n  &.scrollX {\n    overflow-x: auto;\n  }\n  tr:nth-child(even) {\n    // background-color: rgb(243, 242, 242);\n    background-color: rgb(233 241 251 / 40%);\n  }\n\n  tr:nth-child(odd) {\n    background-color: white;\n  }\n\n  tbody {\n    tr {\n      &:hover {\n        background-color: #426ca62f;\n      }\n    }\n  }\n  &:focus {\n    outline: none;\n  }\n}\n\n.tableCenterText {\n  tr td {\n    text-align: center;\n  }\n}\n\n.project_list_kp {\n  max-width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  background: #ffffff;\n  margin-bottom: 5px;\n  background: #ffffff;\n  border: 1px solid #58595d35;\n  border-bottom: 0;\n  position: relative;\n  &.scrollX {\n    overflow-x: scroll;\n  }\n\n  .kpf_table_tr:hover {\n    background-color: #426ca62f;\n  }\n}\n.row-even {\n  background-color: rgb(233 241 251 / 40%);\n}\n\n.row-odd {\n  background-color: white;\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n}\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 15px rgba(103, 149, 187, 0.566);\n}\n::-webkit-scrollbar-thumb {\n  box-shadow: inset 0 0 15px rgba(103, 149, 187, 0.486);\n}\n.radio_container {\n  display: flex;\n  justify-content: center;\n}\n.circules_box {\n  width: 14px;\n  height: 14px;\n  position: relative;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  .circule1 {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 14px;\n    width: 14px;\n    background-color: #eee;\n    border-radius: 50%;\n  }\n  .circule2 {\n    position: absolute;\n    top: 3.3px;\n    left: 3.3px;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n  }\n}\n\n.availability_circule_box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin: 0 10px;\n\n  & .outer_circle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    box-sizing: content-box;\n\n    width: 12px;\n    height: 12px;\n\n    border-radius: 50%;\n    background-color: white;\n    border: 1px solid #426ca65e;\n\n    & .inner_circle {\n      flex-shrink: 0;\n      width: 8px;\n      height: 8px;\n      border-radius: 50%;\n    }\n  }\n}\n\n.item_selected {\n  td {\n    text-decoration: underline;\n    font-weight: 550;\n  }\n}\n\ntd {\n  white-space: nowrap; /* Запрет переноса текста на новую строку */\n  overflow: hidden; /* Скрытие текста, выходящего за пределы ячейки */\n  text-overflow: ellipsis;\n}\n\n.table {\n  max-width: 48vw;\n  display: inline-block;\n  border-spacing: 0;\n  // border: 1px solid black;\n\n  .tr {\n    :last-child {\n      .td {\n        border-bottom: 0;\n      }\n    }\n  }\n\n  .th,\n  .td {\n    margin: 0;\n    padding: 0.5rem;\n    border-bottom: 1px solid black;\n    border-right: 1px solid black;\n    position: relative;\n\n    :last-child {\n      border-right: 0;\n    }\n\n    .resizer {\n      display: inline-block;\n      background: blue;\n      width: 5px;\n      height: 100%;\n      position: absolute;\n      right: 0;\n      top: 0;\n      transform: translateX(50%);\n      z-index: 1;\n\n      touch-action: none;\n\n      &.isResizing {\n        background: red;\n      }\n    }\n  }\n}\n\n.table_container {\n  max-width: 50vw;\n}\n\nthead {\n  width: 100%;\n  position: sticky;\n  height: auto;\n  top: 0;\n  background: white;\n  z-index: 50;\n  overflow: auto;\n  border-bottom: 0.01px solid #58595d4b;\n  border-collapse: separate;\n  th {\n    border-collapse: separate;\n    font-style: normal;\n    font-weight: 500;\n    color: #426ba6;\n    align-items: center;\n    text-align: center;\n\n    border-right: 0.01px solid #58595d4b;\n    border-bottom: 0.01px solid #58595d4b;\n    &:last-child {\n      border-right: 0;\n    }\n  }\n}\ntable {\n  thead {\n    border-collapse: separate;\n  }\n  tbody {\n    border-collapse: collapse;\n  }\n}\n\n.table_with_bb {\n  max-width: 100%;\n\n  overflow-x: scroll;\n  background: #ffffff;\n  margin-bottom: 5px;\n  background: #ffffff;\n  border: 1px solid #58595d35;\n  border-bottom: 0;\n  position: relative;\n\n  thead {\n    height: 1.5em;\n    tr {\n      background-color: #426ca62f;\n    }\n  }\n  table {\n    tr {\n      border-bottom: 1px solid #426ca63b;\n      &:hover {\n        background-color: #426ca62f;\n      }\n      &:last-child {\n        border-bottom: 0;\n      }\n    }\n  }\n}\n\n.table_dnd_container {\n  // max-width: 100%;\n\n  overflow-x: scroll;\n  // position: relative;\n  // overflow: scroll;\n\n  // background: #FFFFFF;\n  // margin-bottom: 5px;\n  // background: #FFFFFF;\n  // border: 1px solid #58595d35;\n  // border-bottom:0;\n  // position: relative;\n  // .project_table {\n  //   // overflow-x: scroll;\n  // }\n  .project_list {\n    overflow-x: scroll;\n  }\n}\n.table_xscroll__container {\n  .project_list {\n    overflow-x: auto;\n  }\n}\n\n.modal_form__child {\n  .project_list {\n    // display: flex;\n    // align-self: stretch;\n    // min-height: 100%;\n  }\n}\n\n.strikethroughRow {\n  position: relative;\n  text-decoration: line-through;\n  color: #a3b9d9;\n}\n\n.sortableHeader {\n  position: relative;\n  cursor: pointer;\n\n  &::after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 6px;\n    height: 6px;\n    background-image: linear-gradient(to bottom right, transparent 50%, #426ba6 0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
